// removed by extract-text-webpack-plugin
module.exports = {"aboutContents":"aboutContents__2MKGY","achievementsWrapper":"achievementsWrapper__3it2A","tileContainer":"tileContainer__3vbI9","imageContainer":"imageContainer__2iYUp","image":"image__hLe5P","arrowSize":"arrowSize__30mL_","merchantSliderContainer":"merchantSliderContainer__gW8DK","customPagination":"customPagination__3YjkX","pagination":"pagination__3NQhT"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVC/merchantsCarousel/style.css
// module id = vqjT
// module chunks = 380